import React, { useEffect, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { RxCross2 } from "react-icons/rx";
import { useGlobalContext } from "../../../../Contexts/GlobalContext";
import axios from "axios";
import { BASE_URL } from "../../../../Utlils";
import { CircularProgress } from "@mui/material";
import { MdOutlineModeEditOutline } from "react-icons/md";
import { IoTrashBinOutline } from "react-icons/io5";
import QualificationLoader from "./QualificationLoader";
import NoData from "../../../../components/NoData";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
};

const Quotas = ({
  data,
  type,
  id,
  getSingleSurvey,
  qualificationTable,
  getTableQualification,
}) => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState({ selectQuestion: false, change: false });
  const { setSnackbar } = useGlobalContext();
  const [inputData, setInputData] = useState({});
  const [filters, setFilters] = useState({});
  const [quotaStats, setQuotaStats] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [editQuotaModal, setEditQuotaModal] = useState(false);
  const [tableConfig, setTableConfig] = useState({
    loading: true,
    error: false,
  });
  const handleOpen = (name) => setOpen((prev) => ({ ...prev, [name]: true }));
  const handleClose = (name) => {
    setOpen((prev) => ({ ...prev, [name]: false }));
    setInputData({});
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (editQuotaModal) {
        const { question, _id, ...rest } = selectedRows?.[0];
        let singleQualification = qualificationTable?.find(
          (d) => d?._id == _id
        );
        await axios.put(`${BASE_URL}/survey/add-quota?sid=${id}&qid=${_id}`, {
          ...singleQualification?.quotas,
          ...rest,
        });
      } else {
        await axios.put(
          `${BASE_URL}/survey/add-quota?sid=${id}&qid=${inputData?.selectedQuestion}`,
          inputData?.quota
        );
      }
      getSingleSurvey();
      await getTableQualification();
      setSnackbar({
        msg: "Quota Added Successfully !",
        open: true,
        severity: "success",
      });
    } catch (error) {
      console.log(error);
      setSnackbar({
        msg: "Something went wrong !",
        open: true,
        severity: "error",
      });
    } finally {
      setLoading(false);
      setEditQuotaModal(false);
      setInputData({});
      setSelectedRows([]);
      setOpen((prev) => ({ ...prev, change: false }));
    }
  };
  const deleteQuota = async (e) => {
    e.preventDefault();
    try {
      let allQuestion = data?.qualification;
      for (let question of allQuestion) {
        let { quotas } = question;
        for (let quota of selectedRows) {
          Object.keys(quota)?.forEach((d) => {
            if (quotas?.hasOwnProperty(d)) {
              delete quotas?.[d];
            }
          });
        }
      }
      await axios.put(`${BASE_URL}/survey?id=${id}`, {
        qualification: allQuestion,
      });
      setSnackbar({
        msg: "Quotas deleted successfully !",
        open: true,
        severity: "success",
      });
    } catch (error) {
      setSnackbar({
        msg: "Something went wrong !",
        open: true,
        severity: "error",
      });
    } finally {
      setSelectedRows([]);
      await getSingleSurvey();
      await getTableQualification();
    }
  };

  const getQuotaStats = async (e) => {
    try {
      setTableConfig((prev) => ({ ...prev, loading: true }));
      let data = await axios.get(`${BASE_URL}/session/quota-stats?sId=${id}`);
      setQuotaStats(data?.data);
      setTableConfig((prev) => ({ ...prev, loading: false }));
    } catch (error) {
      console.log("error in getting quota stats");
      setTableConfig((prev) => ({ ...prev, loading: false, error: true }));
    }
  };
  const selectQuotaRow = (e, data, OD) => {
    if (e.target.checked) {
      setSelectedRows((prev) => [...prev, data]);
    } else {
      setSelectedRows((prev) => prev.filter((d, i) => !d.hasOwnProperty(OD)));
    }
  };
  const filteredAddQuota = qualificationTable
    ?.filter(
      (d) =>
        d?.question?.questionType !== "Text - Open-end" &&
        d?.question?.questionType !== "Numeric - Open-end" &&
        (!d?.quotas || !Object.keys(d?.quotas)?.length)
    )
    ?.filter((fd) =>
      !inputData?.searchQuestion
        ? fd
        : fd?.question?.questionName
            ?.toLowerCase()
            ?.includes(inputData?.searchQuestion?.toLowerCase())
    );
  const filteredQuotaTable = qualificationTable
    ?.filter((f) =>
      !filters?.questionName
        ? f
        : f?.question?.questionName === filters?.questionName
    )
    ?.filter((d) => d?.quotas);
  useEffect(() => {
    getQuotaStats();
  }, [data]);
  // console.log("id=>", id);
  // console.log("quotaStats=>", quotaStats);
  // console.log("inputData=>", inputData);
  // console.log("qualificationTable=>", qualificationTable);
  // console.log("selectedRows=>", selectedRows);
  // console.log("filteredQuotaTable=>", filteredQuotaTable);
  return (
    <div className="w-full flex flex-col gap-6">
      {/* Header */}
      <div className="w-full py-4 px-6 bg-white border-b border-[#E0E0E0]">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-[#0226BE] text-[24px] font-[500] mb-1">
              Quotas
            </h1>
            <p className="text-[#666] text-[14px] font-[400]">
              Manage survey quotas and track completion progress
            </p>
          </div>
          <button
            className="px-4 py-2 text-white rounded-md bg-[#0226BE] text-[14px] font-[500] hover:bg-[#021ea8] transition-colors"
            onClick={(e) => handleOpen("selectQuestion")}
          >
            Add Quota
          </button>
        </div>
      </div>

      {/* Filter Section */}
      <div className="w-full flex items-center justify-between bg-white border border-[#E0E0E0] rounded-md p-4">
        <select
          name=""
          id=""
          className="border border-[#E0E0E0] rounded-md py-2 px-4 text-[#333] text-[14px] h-[40px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-transparent"
          onChange={(e) =>
            setFilters((prev) => ({ ...prev, questionName: e.target.value }))
          }
        >
          <option value="">Filter by Question Name</option>
          {qualificationTable?.map((d, key) => (
            <option value={d?.question?.questionName} key={key}>
              {d?.question?.questionName}
            </option>
          ))}
        </select>
      </div>

      {/* Selected Actions Bar */}
      {selectedRows?.length > 0 && (
        <div className="w-full bg-white border border-[#E0E0E0] rounded-md p-4 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <input
              type="checkbox"
              className="w-4 h-4 cursor-pointer"
              checked={selectedRows?.length > 0}
              onChange={(e) => {
                setSelectedRows([]);
              }}
            />
            <span className="text-[14px] text-[#0226BE] font-[500]">
              Selected: ({selectedRows?.length})
            </span>
            {selectedRows?.length === 1 && (
              <button
                onClick={(e) => {
                  setEditQuotaModal(true);
                }}
                className="p-2 hover:bg-gray-100 rounded-md transition-colors"
              >
                <MdOutlineModeEditOutline
                  size={20}
                  className="text-[#0226BE] cursor-pointer"
                />
              </button>
            )}
            <button
              onClick={deleteQuota}
              className="p-2 hover:bg-gray-100 rounded-md transition-colors"
            >
              <IoTrashBinOutline
                size={20}
                className="text-red-500 cursor-pointer"
              />
            </button>
          </div>
        </div>
      )}

      {/* Quotas Table */}
      <div className="w-full bg-white border border-[#E0E0E0] rounded-md overflow-hidden">
        {tableConfig?.loading ? (
          <div className="p-8">
            <QualificationLoader />
          </div>
        ) : tableConfig?.error ? (
          <div className="h-[200px] flex items-center justify-center">
            <h1 className="text-[#666]">Something went wrong</h1>
          </div>
        ) : !filteredQuotaTable?.length ? (
          <div className="p-8">
            <NoData
              msg={
                <div className="flex items-center gap-2 cursor-pointer">
                  <span>Try adding a</span>
                  <span
                    className="text-[#0226BE] font-[500] underline underline-offset-2 decoration-2 hover:no-underline"
                    onClick={(e) => handleOpen("selectQuestion")}
                  >
                    New Quota
                  </span>
                </div>
              }
            />
          </div>
        ) : (
          <div className="w-full overflow-x-auto containerScroll">
            <table className="whitespace-nowrap text-left w-full">
              <thead className="h-[50px] bg-gray-50 border-b border-[#E0E0E0]">
                <tr>
                  <th className="text-[#666] text-[13px] font-[500] px-4 text-start w-12">
                    {/* Checkbox column */}
                  </th>
                  <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                    Question Name
                  </th>
                  <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                    Quota Name
                  </th>
                  <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                    Quota
                  </th>
                  <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                    Completes
                  </th>
                  <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                    Total Remaining
                  </th>
                  <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                    Conversion
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredQuotaTable?.map((mData, ind) => (
                  <>
                    {Object?.keys(mData?.quotas)?.map((OD, key) => (
                      <tr
                        key={key}
                        className="border-b border-[#E0E0E0] transition-colors cursor-pointer hover:bg-blue-50/30"
                      >
                        <td className="px-4 py-4">
                          <input
                            type="checkbox"
                            className="w-4 h-4 cursor-pointer"
                            checked={selectedRows?.some(
                              (d, i) => d?.[OD] == mData?.quotas?.[OD]
                            )}
                            onChange={(e) =>
                              selectQuotaRow(
                                e,
                                {
                                  [OD]: mData?.quotas?.[OD],
                                  question: mData?.question?._id,
                                  _id: mData?._id,
                                },
                                OD
                              )
                            }
                          />
                        </td>
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px]">
                          {mData?.question?.questionName}
                        </td>
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px] capitalize">
                          {OD}
                        </td>
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px]">
                          {mData?.quotas?.[OD]}
                        </td>
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px]">
                          {mData?.question?.questionType?.endsWith("end")
                            ? Object.values(
                                quotaStats?.[mData?._id] || {}
                              )?.reduce((acc, curr) => (acc += curr), 0)
                            : quotaStats?.[mData?._id]?.[OD] || 0}
                        </td>
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px]">
                          {mData?.question?.questionType?.endsWith("end")
                            ? mData?.quotas?.[OD] -
                                Object.values(
                                  quotaStats?.[mData?._id] || {}
                                )?.reduce((acc, curr) => (acc += curr), 0) >
                              0
                              ? mData?.quotas?.[OD] -
                                Object.values(
                                  quotaStats?.[mData?._id] || {}
                                )?.reduce((acc, curr) => (acc += curr), 0)
                              : 0
                            : (mData?.quotas?.[OD] -
                                quotaStats?.[mData?._id]?.[OD] || 0) > 0
                            ? mData?.quotas?.[OD] -
                              quotaStats?.[mData?._id]?.[OD] || 0
                            : 0}
                        </td>
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px]">
                          {mData?.question?.questionType?.endsWith("end")
                            ? (
                                (Object.values(
                                  quotaStats?.[mData?._id] || {}
                                )?.reduce((acc, curr) => (acc += curr), 0) /
                                  mData?.quotas?.[OD]) *
                                100
                              )?.toFixed(2)
                            : (
                                ((quotaStats?.[mData?._id]?.[OD] || 0) /
                                  mData?.quotas?.[OD] ?? 0) * 100
                              )?.toFixed(2)}
                          %
                        </td>
                      </tr>
                    ))}
                  </>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* select Question */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open?.selectQuestion}
        onClose={(e) => handleClose("selectQuestion")}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open?.selectQuestion}>
          <Box sx={style}>
            <div className="w-full flex items-center flex-col">
              <div className="w-full py-4 px-6 border-b border-[#E0E0E0] flex items-center justify-between">
                <h1 className="text-[#333] text-[18px] font-[500]">
                  Select Question
                </h1>
                <button
                  onClick={(e) => handleClose("selectQuestion")}
                  className="p-1 hover:bg-gray-100 rounded-md transition-colors"
                >
                  <RxCross2 size={18} className="text-[#666]" />
                </button>
              </div>

              <form
                className="w-full py-4 px-6 flex flex-col gap-4"
                onSubmit={(e) => {
                  e.preventDefault();
                  setOpen((prev) => ({
                    ...prev,
                    change: true,
                    selectQuestion: false,
                  }));
                }}
              >
                <div className="flex flex-col gap-2">
                  <label className="text-[#333] text-[14px] font-[500]">
                    Search Question
                  </label>
                  <input
                    type="text"
                    placeholder="Question Name"
                    onChange={(e) =>
                      setInputData((prev) => ({
                        ...prev,
                        searchQuestion: e.target.value,
                      }))
                    }
                    name="searchQuestion"
                    className="border border-[#E0E0E0] rounded-md pl-3 h-[40px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-transparent text-[#333] text-[14px]"
                  />
                </div>
                <div className="flex flex-col gap-2 max-h-[200px] overflow-y-auto containerScroll border border-[#E0E0E0] rounded-md py-3 px-4">
                  {filteredAddQuota?.length ? (
                    filteredAddQuota?.map((d) => (
                      <div className="w-full flex items-center gap-3 py-2 hover:bg-gray-50 rounded-md px-2">
                        <input
                          type="radio"
                          id={d?.question?.questionName}
                          name="selectedQuestion"
                          required={inputData?.selectedQuestion ? false : true}
                          checked={inputData?.selectedQuestion === d?._id}
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setInputData((prev) => ({
                                ...prev,
                                selectedQuestion: d?._id,
                              }));
                            } else {
                              setInputData((prev) => ({
                                ...prev,
                                selectedQuestion: "",
                              }));
                            }
                          }}
                          className="w-4 h-4 cursor-pointer"
                        />
                        <label
                          htmlFor={d?.question?.questionName}
                          className="text-[14px] font-[400] text-[#333] w-full cursor-pointer"
                        >
                          {d?.question?.questionName || "-"}
                        </label>
                      </div>
                    ))
                  ) : (
                    <p className="text-[13px] text-[#666] text-center py-2">
                      Try adding new qualification
                    </p>
                  )}
                </div>

                <button
                  type="submit"
                  className="text-white text-[14px] font-[500] bg-[#0226BE] rounded-md py-2 px-4 w-fit self-center hover:bg-[#021ea8] transition-colors"
                >
                  Continue
                </button>
              </form>
            </div>
          </Box>
        </Fade>
      </Modal>
      {/* change quota */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open?.change}
        onClose={(e) => {
          handleClose("change");
          setLoading(false);
        }}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open?.change}>
          <Box sx={{ ...style, width: 600 }}>
            <div className="w-full flex items-center flex-col">
              <div className="w-full py-4 px-6 border-b border-[#E0E0E0] flex items-center justify-between">
                <h1 className="text-[#333] text-[18px] font-[500]">
                  Change Qualification Quota
                </h1>
                <button
                  onClick={(e) => {
                    handleClose("change");
                    setLoading(false);
                  }}
                  className="p-1 hover:bg-gray-100 rounded-md transition-colors"
                >
                  <RxCross2 size={18} className="text-[#666]" />
                </button>
              </div>

              <form
                className="w-full flex flex-col gap-4 py-4 px-6"
                onSubmit={handleSubmit}
              >
                <div className="w-full pb-4 flex flex-col gap-4 border border-[#E0E0E0] rounded-md p-4">
                  <div className="w-full pb-3 border-b border-[#E0E0E0] flex flex-wrap justify-between gap-2">
                    <h1 className="text-[#333] font-[500] text-[14px] capitalize">
                      {qualificationTable?.find(
                        (d) => d?._id === inputData?.selectedQuestion
                      )?.question?.questionText || "-"}
                    </h1>
                    <p className="text-[#333] font-[600] text-[14px]">
                      Total Quotas: {data?.expectedMatrix?.expectedCompletes}
                    </p>
                  </div>
                  <div className="flex flex-col gap-[18px] px-5 max-h-[200px]  overflow-y-auto containerScroll ">
                    {qualificationTable?.find(
                      (d) => d?._id === inputData?.selectedQuestion
                    )?.question?.questionType === "Numeric - Open-end" ? (
                      <>
                        {qualificationTable
                          ?.find((d) => d?._id === inputData?.selectedQuestion)
                          ?.validOptions?.map((d, i) => (
                            <div className="w-full flex gap-3 items-center justify-between py-2">
                              <div className="flex items-center gap-3">
                                <input
                                  type="Number"
                                  className="border border-[#E0E0E0] w-[100px] h-[40px] rounded-md bg-[#F5F5F5] pl-3 text-[14px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-transparent"
                                  value={d?.from}
                                  readOnly
                                />
                                <span className="text-[#666]">To</span>
                                <input
                                  type="Number"
                                  className="border border-[#E0E0E0] w-[100px] h-[40px] rounded-md bg-[#F5F5F5] pl-3 text-[14px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-transparent"
                                  value={d?.to}
                                  readOnly
                                />
                              </div>
                              <span className="text-[#666]">-</span>
                              <input
                                type="Number"
                                value={
                                  inputData?.quota?.[`${d?.from}-${d?.to}`] ||
                                  ""
                                }
                                className="border border-[#E0E0E0] w-[100px] h-[40px] rounded-md bg-white pl-3 text-[14px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-transparent"
                                placeholder="0"
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "e" ||
                                    e.key === "+" ||
                                    e.key === "-"
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={(e) => {
                                  if (
                                    /^\d*$/.test(e.target.value) ||
                                    e.target.value == ""
                                  ) {
                                    if (
                                      Number(e.target.value) <=
                                      Number(
                                        data?.expectedMatrix?.expectedCompletes
                                      )
                                    ) {
                                      setInputData((prev) => ({
                                        ...prev,
                                        quota: {
                                          ...prev.quota,
                                          [`${d?.from}-${d?.to}`]: Number(
                                            e.target.value
                                          ),
                                        },
                                      }));
                                    } else {
                                      setSnackbar({
                                        open: true,
                                        msg: "Allocation cant be more than expected completes",
                                        severity: "error",
                                      });
                                    }
                                  }
                                }}
                              />
                            </div>
                          ))}
                      </>
                    ) : (
                      qualificationTable
                        ?.find((d) => d?._id === inputData?.selectedQuestion)
                        ?.validOptions?.map((d, i) => (
                          <div
                            className="w-full flex items-center justify-between py-2"
                            key={i}
                          >
                            <h1 className="capitalize font-[400] text-[14px] text-[#333]">
                              {d}
                            </h1>
                            <input
                              type="Number"
                              value={inputData?.quota?.[d] || ""}
                              className="border border-[#E0E0E0] w-[100px] h-[40px] rounded-md bg-white pl-3 text-[14px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-transparent"
                              placeholder="0"
                              onKeyDown={(e) => {
                                if (
                                  e.key === "e" ||
                                  e.key === "+" ||
                                  e.key === "-"
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e) => {
                                if (
                                  /^\d*$/.test(e.target.value) ||
                                  e.target.value == ""
                                ) {
                                  if (
                                    Number(e.target.value) <=
                                    Number(
                                      data?.expectedMatrix?.expectedCompletes
                                    )
                                  ) {
                                    setInputData((prev) => ({
                                      ...prev,
                                      quota: {
                                        ...prev.quota,
                                        [d]: Number(e.target.value),
                                      },
                                    }));
                                  } else {
                                    setSnackbar({
                                      open: true,
                                      msg: "Allocation cant be more than expected completes",
                                      severity: "error",
                                    });
                                  }
                                }
                              }}
                            />
                          </div>
                        ))
                    )}
                  </div>
                </div>
                {loading ? (
                  <div className="flex justify-center w-full">
                    <CircularProgress className="text-[#0226BE]" size={24} />
                  </div>
                ) : (
                  <button
                    type="submit"
                    className="text-white text-[14px] font-[500] bg-[#0226BE] rounded-md py-2 px-6 w-fit self-center hover:bg-[#021ea8] transition-colors"
                  >
                    Save
                  </button>
                )}
              </form>
            </div>
          </Box>
        </Fade>
      </Modal>
      {/* edit quota */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={editQuotaModal}
        onClose={(e) => {
          setEditQuotaModal(false);
          setLoading(false);
        }}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={editQuotaModal}>
          <Box sx={{ ...style, width: 600 }}>
            <div className="w-full flex items-center flex-col">
              <div className="w-full py-4 px-6 border-b border-[#E0E0E0] flex items-center justify-between">
                <h1 className="text-[#333] text-[18px] font-[500]">
                  Edit Qualification Quota
                </h1>
                <button
                  onClick={(e) => {
                    setEditQuotaModal(false);
                  }}
                  className="p-1 hover:bg-gray-100 rounded-md transition-colors"
                >
                  <RxCross2 size={18} className="text-[#666]" />
                </button>
              </div>
              <form
                className="w-full flex flex-col gap-4 py-4 px-6"
                onSubmit={handleSubmit}
              >
                <div className="w-full pb-4 flex flex-col gap-4 border border-[#E0E0E0] rounded-md p-4">
                  <div className="w-full pb-3 border-b border-[#E0E0E0] flex flex-wrap justify-between gap-2">
                    <h1 className="text-[#333] font-[500] text-[14px] capitalize">
                      {qualificationTable?.find(
                        (d) => d?._id === selectedRows?.[0]?._id
                      )?.question?.questionText || "-"}
                    </h1>
                    <p className="text-[#333] font-[600] text-[14px]">
                      Total Quotas: {data?.expectedMatrix?.expectedCompletes}
                    </p>
                  </div>
                  <div className="flex flex-col gap-4 max-h-[250px] overflow-y-auto containerScroll">
                    {qualificationTable?.find(
                      (d) => d?._id === selectedRows?.[0]?._id
                    )?.question?.questionType === "Numeric - Open-end" ? (
                      <>
                        {qualificationTable
                          ?.find((d) => d?._id === selectedRows?.[0]?._id)
                          ?.validOptions?.map((d, i) => (
                            <div className="w-full flex gap-3 items-center justify-between py-2">
                              <div className="flex items-center gap-3">
                                <input
                                  type="Number"
                                  className="border border-[#E0E0E0] w-[100px] h-[40px] rounded-md bg-[#F5F5F5] pl-3 text-[14px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-transparent"
                                  value={d?.from}
                                  readOnly
                                />
                                <span className="text-[#666]">To</span>
                                <input
                                  type="Number"
                                  className="border border-[#E0E0E0] w-[100px] h-[40px] rounded-md bg-[#F5F5F5] pl-3 text-[14px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-transparent"
                                  value={d?.to}
                                  readOnly
                                />
                              </div>
                              <span className="text-[#666]">-</span>
                              <input
                                type="Number"
                                value={
                                  selectedRows?.[0]?.[`${d?.from}-${d?.to}`] ||
                                  ""
                                }
                                className="border border-[#E0E0E0] w-[100px] h-[40px] rounded-md bg-white pl-3 text-[14px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-transparent"
                                placeholder="0"
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "e" ||
                                    e.key === "+" ||
                                    e.key === "-"
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={(e) => {
                                  if (
                                    /^\d*$/.test(e.target.value) ||
                                    e.target.value == ""
                                  ) {
                                    if (
                                      Number(e.target.value) <=
                                      Number(
                                        data?.expectedMatrix?.expectedCompletes
                                      )
                                    ) {
                                      let Obj = selectedRows?.[0];
                                      Obj[`${d?.from}-${d?.to}`] = Number(
                                        e.target.value
                                      );
                                      setSelectedRows([Obj]);
                                    } else {
                                      setSnackbar({
                                        open: true,
                                        msg: "Allocation cant be more than expected completes",
                                        severity: "error",
                                      });
                                    }
                                  }
                                }}
                              />
                            </div>
                          ))}
                      </>
                    ) : (
                      qualificationTable
                        ?.find((d) => d?._id === selectedRows?.[0]?._id)
                        ?.validOptions?.filter((d, i) =>
                          selectedRows?.[0]?.hasOwnProperty(d)
                        )
                        ?.map((d, i) => (
                          <div
                            className="w-full flex items-center justify-between py-2"
                            key={i}
                          >
                            <h1 className="capitalize font-[400] text-[14px] text-[#333]">
                              {d}
                            </h1>
                            <input
                              type="Number"
                              value={selectedRows?.[0]?.[d] || ""}
                              className="border border-[#E0E0E0] w-[100px] h-[40px] rounded-md bg-white pl-3 text-[14px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-transparent"
                              placeholder="0"
                              onKeyDown={(e) => {
                                if (
                                  e.key === "e" ||
                                  e.key === "+" ||
                                  e.key === "-"
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e) => {
                                if (
                                  /^\d*$/.test(e.target.value) ||
                                  e.target.value == ""
                                ) {
                                  if (
                                    Number(e.target.value) <=
                                    Number(
                                      data?.expectedMatrix?.expectedCompletes
                                    )
                                  ) {
                                    let Obj = selectedRows?.[0];
                                    Obj[d] = Number(e.target.value);
                                    setSelectedRows([Obj]);
                                  } else {
                                    setSnackbar({
                                      open: true,
                                      msg: "Allocation cant be more than expected completes",
                                      severity: "error",
                                    });
                                  }
                                }
                              }}
                            />
                          </div>
                        ))
                    )}
                  </div>
                </div>
                {loading ? (
                  <div className="flex justify-center w-full">
                    <CircularProgress className="text-[#0226BE]" size={24} />
                  </div>
                ) : (
                  <button
                    type="submit"
                    className="text-white text-[14px] font-[500] bg-[#0226BE] rounded-md py-2 px-6 w-fit self-center hover:bg-[#021ea8] transition-colors"
                  >
                    Update
                  </button>
                )}
              </form>
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default Quotas;
